(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tg-new-badge"] && !Shopify.designMode) return;
  try {
    function expireNewBadges(){document.querySelectorAll('[data-new-until]').forEach(badge=>{if(Date.now()/1000>=Number(badge.dataset.newUntil))badge.remove()})}expireNewBadges();document.addEventListener('visibilitychange',expireNewBadges);setInterval(expireNewBadges,60000);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tg-size-chart"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('tg-size-chart'))customElements.define('tg-size-chart',class extends HTMLElement{
 connectedCallback(){this.abort=new AbortController();const opts={signal:this.abort.signal};this.dialog=this.querySelector('dialog');this.link=this.querySelector('[data-chart-open]');this.link.addEventListener('click',e=>{e.preventDefault();this.dialog.showModal()},opts);this.querySelector('[data-chart-close]').addEventListener('click',()=>this.dialog.close(),opts);this.dialog.addEventListener('click',e=>{const b=this.dialog.getBoundingClientRect();if(e.target===this.dialog&&(e.clientX<b.left||e.clientX>b.right||e.clientY<b.top||e.clientY>b.bottom))this.dialog.close()},opts);this.dialog.addEventListener('close',()=>this.link.focus({preventScroll:true}),opts)}
 disconnectedCallback(){this.abort?.abort();if(this.dialog?.open)this.dialog.close()}
});
  } catch(e) { console.error(e); }
})();

})();
